import React from "react";
import ReactDOM from "react-dom";
import { RecoilRoot } from "recoil";
import { HashRouter as Router } from "react-router-dom";
import App from "./app";

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <Router>
        <App />
      </Router>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root"),
);

document.querySelector("body").removeAttribute("react-cloak");
